/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import axios from 'axios';
// import Modal from "react-responsive-modal";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import parse from 'html-react-parser';
import ReplayItem from '../components/customer/ReplayItem';

import CustomerEdit from '../containers/customer/CustomerEdit';

class BoardDetail extends Component {
  state = {
    edit: false,
  };
  componentDidMount = () => {
    const { board_idx } = this.props.childProps;

    if (board_idx === 0 || board_idx === undefined || board_idx === '') {
    } else {
      this._getData();
    }
  };
  _getData = async () => {
    const result = await this._getDataApi();
    const intReturn = result.data[0].intReturn;
    const data = result.data[0].listData;

    if (intReturn === 0) {
      this.setState({
        data,
      });
    }
  };
  _getDataApi = () => {
    const { apiUrl } = this.props;
    const { board_idx } = this.props.childProps;

    return axios
      .post(apiUrl + '/boardDetail', {
        params: {
          idx: board_idx,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  _onClose = () => {
    const { setBoardIdx } = this.props;
    setBoardIdx(0);
  };
  _showEdit = () => {
    this.setState({
      edit: true,
    });
  };
  _closeEdit = () => {
    this.setState({
      edit: false,
    });
  };
  render() {
    const { data, edit } = this.state;
    const { loginId, imgUrl } = this.props;
    return (
      <Fragment>
        <div className="detail_layer_pop">
          <div className="detail_view">
            <div
              className="detail_layer_close"
              style={{ cursor: 'pointer' }}
              onClick={this._onClose}
            >
              <img src={imgUrl + '/img/detail_img/close_1.png'} />
            </div>

            {data ? (
              edit ? (
                <div className="detail_view_layer d_plus">
                  <CustomerEdit
                    closeEdit={this._closeEdit}
                    getData={this._getData}
                    id={data[0].id}
                    title={data[0].title}
                    content={data[0].content}
                    categoryID={data[0].categoryID.toString()}
                    board_id={data[0].board_id}
                    chkNotice={data[0].chkNotice}
                    idx={data[0].idx}
                  />
                </div>
              ) : (
                <div className="detail_view_layer d_plus">
                  <div className="detil_new">
                    <div className="titarea">
                      <div className="tit">
                        <span>{data[0].writeDay}</span>
                        {data[0].title}{' '}
                        {loginId === data[0].id ? (
                          <div
                            style={{
                              fontColor: '#ff5d24',
                              cursor: 'pointer',
                              width: '100%',
                              textAlign: 'right',
                            }}
                            onClick={this._showEdit}
                          >
                            [글수정] &nbsp;
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="detil_content">
                      <div className="sample_txt">{parse(data[0].content)}</div>
                    </div>
                    {data[0].board_id === 9 ? (
                      data[0].replay_idx === 0 ? null : (
                        <div className="detil_content">
                          <div className="sample_txt">
                            <ReplayItem replay_idx={data[0].replay_idx} />
                          </div>
                        </div>
                      )
                    ) : null}
                  </div>
                </div>
              )
            ) : (
              <div className="detail_view_layer d_plus">
                존재하지 않는 글입니다.
              </div>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(BoardDetail));
